import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Login from '../view/Login';
import MainLayout from '../layout/MainLayout';
import Certification from '../view/Certification';
import Member from '../view/Member';
import PrivateRoute from './PrivateRoute';
import AuthRoute from './AuthRoute';
import useTokenUpdate from '../hooks/useTokenUpdate';

const Router = () => {
    const accessToken = localStorage.getItem('accessToken');
    useTokenUpdate();

    return (
        <>
            <Routes>
                <Route path="/" element={<Navigate to={accessToken ? "/certification" : "/login"} />} />
                <Route path="/login" element={<AuthRoute><Login/></AuthRoute>}/>
                <Route element={<MainLayout />}>
                    <Route path="/certification" element={<PrivateRoute><Certification/></PrivateRoute>}/>
                    <Route path="/certification" element={<Certification/>}/>
                    <Route path="/member" element={<PrivateRoute><Member/></PrivateRoute>}/>
                </Route>
            </Routes>
        </>
    );
};

export default Router;
